export default __webpack_public_path__ + "static/media/avatar.03ab98b2.png";